import { Navigate } from 'react-router-dom'
import { useAdminAuth } from '../hooks/useAdminAuth.js'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, isLoading, logout } = useAdminAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (!isAdmin) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-400 mb-2">Access Denied</h1>
          <p className="text-gray-400 mb-6">You do not have admin permissions.</p>
          <button
            onClick={logout}
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-gray-800 hover:bg-gray-700 text-gray-300 rounded-xl transition-colors text-sm font-medium"
          >
            Sign out
          </button>
        </div>
      </div>
    )
  }

  return children
}

export default ProtectedRoute
